export default "__VITE_ASSET__Bt_Xb2X6__"